// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ResizeOutlinedSvg from "@fishx/icons-svg/es/asn/ResizeOutlined";
import FishxIcon from '../components/FishxIcon';

var ResizeOutlined = function ResizeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ResizeOutlinedSvg
  }));
};

ResizeOutlined.displayName = 'ResizeOutlined';
export default React.forwardRef(ResizeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ResizeOutlined.js
// module id = 4004
// module chunks = 0